import React from 'react'
import styles from './GreenWall.module.css'
import Grid2 from '../Grid/grid2'
import { Banner } from '../Banner/Banner'
import { BannerBench } from '../Banner/BannerBench'

export const Bench: React.FC = () => {
  return (
    <div className={styles.page}>
      {/* HERO */}
      <Banner
        href="/cdn/bench/landing.jpg"
        mobileHref="/cdn/bench/landing-mobile.jpg"
        content={BannerBench}
      ></Banner>

      <section>
        <Grid2
          images={[
            { src: '/cdn/bench/5.jpg' },
            { src: '/cdn/bench/landing.jpg' },
            { src: '/cdn/bench/3.jpg' },
            { src: '/cdn/bench/4.jpg' },
            { src: '/cdn/bench/1.jpg' },
          ]}
          href="/"
        ></Grid2>
      </section>
    </div>
  )
}
